var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramRedesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8A3AB9",
  fillRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.31 15.121c0-.686-.558-1.244-1.244-1.244s-1.245.558-1.245 1.244a1.246 1.246 0 0 0 2.489 0M15.066 12.124a3 3 0 0 1 1.735.555h4.514v-.88a3.16 3.16 0 0 0-3.156-3.155h-6.316A3.16 3.16 0 0 0 8.687 11.8v.88h4.644a3 3 0 0 1 1.735-.556m2.586-1.562c0-.193.158-.35.351-.35h1.084c.193 0 .35.157.35.35v1.083c0 .193-.157.351-.35.351h-1.084a.35.35 0 0 1-.35-.35z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.064 15.122a3 3 0 0 1-2.998 2.997 3 3 0 0 1-2.713-4.271H8.687v4.32a3.16 3.16 0 0 0 3.156 3.155h6.316a3.16 3.16 0 0 0 3.156-3.155v-4.32H17.78c.182.387.285.818.285 1.273",
  clipRule: "evenodd"
})));
export default SvgInstagramRedesign;